<template>
  <div class="relative bg-surface-primary flex flex-col gap-2.5 pt-xl w-[305px] pb-l px-l rounded-4xl h-[419px]">
    <div class="flex flex-col gap-m flex-grow">
      <div class="flex items-start justify-between">
        <div class="flex flex-col gap-2xs flex-1">
          <Skeleton class="h-5 w-4/5 rounded" />
          <Skeleton class="h-5 w-3/5 rounded" />
        </div>
        <Skeleton class="h-8 w-8 rounded-md" />
      </div>
      <div class="flex flex-col gap-3xs">
        <Skeleton class="h-3 w-full rounded" />
        <Skeleton class="h-3 w-full rounded" />
        <Skeleton class="h-3 w-4/5 rounded" />
      </div>
    </div>
    <div class="flex flex-col gap-3xs pr-xl">
      <Skeleton class="h-3 w-1/3 rounded" />
      <Skeleton class="h-3 w-2/3 rounded" />
    </div>
    <div class="absolute bottom-0 right-0 w-[70px] h-[70px] bg-carbon-100 rounded-tl-4xl" />
  </div>
</template>
